


















































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "@/lib/util";
import AbpBase from "@/lib/abpbase";
import PageRequest from "@/store/entities/page-request";
 
class PageRblistcollectoranalyseRequest extends PageRequest {
  Keyword: string;
  isrent: number; //nullable
  stime: Date;
  etime: Date;
}

 @Component({
        components:{}
    })
export default class rblistcollectoranalyse extends AbpBase {
  edit() {
    this.editModalShow = true;
  }
  //filters
  pagerequest: PageRblistcollectoranalyseRequest = new PageRblistcollectoranalyseRequest();
  creationTime: Date[] = [];

  createModalShow: boolean = false;
  editModalShow: boolean = false;
  get list() {
     
    return this.$store.state. rblistcollectoranalyse.list;
  }
  get loading() {
     
    return this.$store.state. rblistcollectoranalyse.loading;
  }
  create() {
    this.createModalShow = true;
  }

  pageChange(page: number) {
    this.$store.commit("rblistcollectoranalyse/setCurrentPage", page);
    this.getpage();
  }
  pagesizeChange(pagesize: number) {
    this.$store.commit("rblistcollectoranalyse/setPageSize", pagesize);
    this.getpage();
  }
  async getpage() {
    this.pagerequest.maxResultCount = this.pageSize;
    this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
    //filters

    if (this.creationTime.length > 0) {
      this.pagerequest.stime = this.creationTime[0];
    }
    if (this.creationTime.length > 1) {
      this.pagerequest.etime = this.creationTime[1];
    }

    await this.$store.dispatch({
      type: "rblistcollectoranalyse/getAll",
      data: this.pagerequest,
    });
    
  }
   
   
 

  get pageSize() {
    return this.$store.state. rblistcollectoranalyse.pageSize;
  }
  get totalCount() {
    return this.$store.state. rblistcollectoranalyse.totalCount;
  }
  get currentPage() {
    return this.$store.state. rblistcollectoranalyse.currentPage;
  }

  columns = [
    {
     
      title: this.L("UserName"),
      key: "login_Name",
    },
     {
      
      title: this.L("Name"),
      key: "name",
    },

    {
      title: this.L("VilName"),
       key: "vilname",
    },
     
     {
      
      title: this.L("用户数"),
      key: "usrnum",
    },
     {
      
      title: this.L("收集次数"),
      key: "num",
    },
     {
      
      title: this.L("空桶数"),
      key: "scorenum",
    },

    {
      
      title: this.L("时间"),
      key: "time",
    },
    
    
    

      
  ];
  async created() {
    this.getpage();
   
     
  }
  //导出
   async  exportExcel() {
   
     this.pagerequest.maxResultCount = 999999999;
     this.pagerequest.skipCount =0;
     let lt= await this.$store.dispatch({
      type: "rblistcollectoranalyse/getAllexportExcel",
      data: this.pagerequest,
    });
 
      if(lt!=null){       
       
            
            
			   	require.ensure( [], () => {
					const { export_json_to_excel } = require('@/lib/excel/export2Excel.js');
          
					// 这里深拷贝，修改值时不会影响到原对象
				   
					lt.map((item) => { // 这里修改要下载的字段内容
        
        	 
					  return item;
					});
    
					const filterVal = ['login_Name','name','vilname', 'usrnum', 'num', 'scorenum', 'time'];// 取出要下载的表头字段
					const tHeader = ['登录帐号','名称','小区','用户数','收集次数','空桶数','时间'];// 把表头字段定义成想要的中文或英文
					const data = this.formatJson(filterVal, lt);
					  export_json_to_excel(tHeader, data, '采集员数据统计');// 定义excel下载成功的表名
					});			
								
             }

        }

			formatJson(filterVal, jsonData) {
			     return jsonData.map(v => filterVal.map(j => v[j]))
			}

}
